<template>
    <header class="header" :class="{'header_guest header_guest-color' : !user}">
        <btn-wrapper
            v-if="user"
            :class="{'header__button_active' : !sidebarIsOpened}"
            @click="getChangeSidebarState"
            :params="{
                class: 'button !bg-default/10 !text-default header__button',
                type: 'div',
                isSlotIsset: true
            }"
        >
            <!--            <svg class="icon icon_size_l icon_color_blue">-->
            <!--                <use xlink:href="/img/sprites/icons-sprite.svg#icon-arrow-left"></use>-->
            <!--            </svg>-->
            <div class="header__line"></div>
            <div class="header__line"></div>
            <div class="header__line"></div>
        </btn-wrapper>
        <div class="header__inner" :class="{
        'header_guest': !user
    }">
            <Logo class="header__logo" :class="{'header__logo_off' : user}"/>
            <div class="header__row">
                <MainSearch class="header__item" v-if="user"/>
                <router-link v-if="!user" class="header__docs" to="/docs">{{ $t('footer.info.docs') }}</router-link>
                <Lang class="header__item" :class="{'header__lang' : user}"/>
                <btn-wrapper
                    v-if="!user"
                    :params="{
                    class: 'header__link bg-default/10',
                    type: 'link',
                    path: '/auth',
                    isSlotIsset: true
                }"
                >
                    <svg class="icon stroke-default mr-1">
                        <use xlink:href="/img/sprites/icons-sprite.svg#icon-entry"></use>
                    </svg>
                    <div class="text-default">{{ $t('footer.info.enter') }}</div>
                </btn-wrapper>
                <template v-if="user">
                    <Notification class="header__item"/>
                    <HeaderUser data-testid="user-block" class="header__item"/>
                </template>
            </div>
        </div>
    </header>
</template>

<script>
import Logo from '@/components/UI/logo/index.vue'
import Lang from './components/Lang.vue'
import Notification from './components/Notification.vue'
import MainSearch from './components/HeaderSearch.vue'
import HeaderUser from './components/HeaderUser.vue'
import {mapGetters, mapActions} from 'vuex'

export default {
    name: 'Header',

    components: {
        Logo,
        Lang,
        Notification,
        MainSearch,
        HeaderUser
    },

    mounted() {
        const sideBarState = JSON.parse(localStorage.getItem('leftSidebar.state'))
        if(sideBarState === null || sideBarState === undefined) {
            this.setSidebarState(true)
            return
        }
        this.setSidebarState(sideBarState)
    },
    computed: {
        ...mapGetters(['user', 'sidebarIsOpened'])
    },

    methods: {
        ...mapActions(['getChangeSidebarState', 'setSidebarState']),
    },
}
</script>

<style lang="scss" scoped>
@import './scss/header.scss';
</style>
